import { ElementIdGenerator } from "../../../classes/element-id-handling";
import { findUpperElement } from "../../../classes/misc-util";
export function getCardCloseButtonId(element) {
    return ElementIdGenerator.createId(findUpperElement(element, "dx-card"), "close");
}
